/* eslint-env browser */
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const baseUrl = '/api/';
export const backendApi = createApi({
  baseQuery: fetchBaseQuery({ baseUrl }),
  tagTypes: ['Applicant', 'Applications', 'SystemMessages'],
  endpoints: (builder) => ({
    getApplicant: builder.query<IApplicant, IApplicantPayload>({
      query: (payload: IApplicantPayload) => `applicant/${payload.auId}?lang=${payload.lang}&phase=${payload.phase}`,
      providesTags: ['Applicant'],
    }),
    getApplications: builder.query<IApplication[], IApplicationPayload>({
      query: (payload: IApplicationPayload) => `applications/${payload.auId}?lang=${payload.lang}&phase=${payload.phase}`,
      providesTags: ['Applications'],
    }),
    getSystemMessages: builder.query<ISystemMessage[], ISystemMessagePayload>({
      query: (payload: ISystemMessagePayload) => `systemmessage/?lang=${payload.lang}&anonymous=${payload.anonymous}`,
      providesTags: ['SystemMessages'],
    }),
    getStudentOrientation: builder.query<IStudentOrientation[], IStudentOrientationPayload>({
      query: (payload: IStudentOrientationPayload) => `studentorientation/${payload.admissionAreaCode}/${payload.period}/?lang=${payload.lang}`,
    }),
    answer: builder.mutation<IAnswerResponse, IAnswerPayload>({
      query: (payload: IAnswerPayload) => ({
        url: `applications/answer/${payload.auId}`,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: payload,
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled; // Wait for the mutation to succeed
          dispatch(
            backendApi.util.invalidateTags(['Applications']), // Invalidate tags only on success
          );
        } catch {
          // Handle errors if needed (e.g., log or show a notification)
        }
      },
    }),
    resendMail: builder.mutation<void, IResendPayload>({
      query: (payload: IAnswerPayload) => ({
        url: `applications/resendMail/${payload.auId}`,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: payload,
      }),
    }),
  }),
});

export const {
  useGetApplicantQuery,
  useGetApplicationsQuery,
  useGetSystemMessagesQuery,
  useGetStudentOrientationQuery,
  useAnswerMutation,
  useResendMailMutation,
} = backendApi;
